module.exports = __webpack_public_path__ + "static/img/logo_levis@3x.7092df1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/payment/logos/logo_levis@3x.png
// module id = R5+g
// module chunks = 1